import React, { useState } from "react";
import axios from "axios";
import { USERS_BASE_URL } from "../services/SignUpService";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   try {
  //     // Ensure the base URL is correct
  //     const response = await axios.post(
  //       `${USERS_BASE_URL}/api/users/list/forgot-password`,
  //       { email }
  //     );
  //     setMessage(response.data.message);
  //     setError("");
  //   } catch (err) {
  //     // Check if error response exists
  //     setError(err.response?.data?.error || "Something went wrong!");
  //     setMessage("");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        `${USERS_BASE_URL}/api/users/forgot-password`,
        { email },
        {
          headers: {
            "Content-Type": "application/json", // Ensure it's sending JSON
          },
        }
      );
      setMessage(response.data.message);
      setError("");
    } catch (err) {
      setError(
        err.response?.data?.error ||
          "Something went wrong! Unable to sent reset password link!!"
      );
      setMessage("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <div className="row vh-100  justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h3 className="card-title text-center">Forgot Password</h3>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Enter your email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                {error && <p className="text-danger">{error}</p>}
                {message && <p className="text-success">{message}</p>}
                <div className="d-grid">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={!email || loading}
                  >
                    {loading ? (
                      <div className="d-flex align-items-center">
                        <div
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                          style={{ width: "1.5rem", height: "1.5rem" }}
                        ></div>
                        <div
                          className="text-white"
                          style={{ fontSize: "12px" }}
                        >
                          Please wait...
                        </div>
                      </div>
                    ) : (
                      <div>Send Reset Link</div>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
